<template>
    <div class="tab-component">
        <div class="tab-component__header">
            <ul class="tab-component__header-items">
                <li class="tab-component__header-item" v-for="(item, index) in tabContents">
                    <button class="tab-component__header-button" @click="toggleTab(index)">
                        <img v-if="isTablet && item.header_icon != null && item.header_icon != false" :src="`${item.header_icon}`" alt="" class="tab-component__header-icon">
                        <h6>{{ item.header }}</h6>
                    </button>
                </li>
            </ul>
        </div>
        <div class="tab-component__content-container">
            <div class="tab-component__contents" :style="`min-height: ${heighestContentTab}`" v-for="(item, index) in tabContents">
                <span class="tab-component__closeModal" @click="closeTab(index)"></span>
                <p class="tab-component__text" v-html="item.content"></p>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { ref, onMounted, reactive } from 'vue';
    const props = defineProps({
        tabComponent: {
            Array,
            default: () => []
        },
    });
    const tabContents = ref();
    const heighestContentTab = ref();
    const numberOfContentTabs = ref();
    const activeTab = ref(0);

    const isTablet = ref(false);

    tabContents.value = props?.tabComponent.tab_content;

    onMounted(() => {
        const tabs = document.querySelectorAll('.tab-component__contents');
        const headers = document.querySelectorAll('.tab-component__header-button')
        
        const observer = new ResizeObserver((body) => {
            if(window.innerWidth < 500) {
                isTablet.value = true;
                calcHeight();
                initialiseMobile(tabs, headers);
            }
            else {
                isTablet.value = false;
                calcHeight();
                initialiseDesktop(tabs , headers);
            }
        });

        observer.observe(document.body)

        if(isTablet.value) {
            // initialiseMobile(tabs, headers);
        }
        else {
            // initialiseDesktop(tabs, headers);
        }
    
    })

    const initialiseMobile = (tabs, headers) => {
        for(let i= 0; i < tabs.length; i++) {
            tabs[i].classList.add('tab-component__contents--disabled')
            headers[i].classList.remove('tab-component__header-button--disabled')
            headers[i].classList.remove('tab-component__header-button--active')
        }
    }
    const initialiseDesktop = (tabs, headers) => {
        for(let i = 0; i< tabs.length; i++) {
            if (i != activeTab.value) {
                tabs[i].classList.add('tab-component__contents--disabled')
                headers[i].classList.add('tab-component__header-button--disabled')
            }
            if(i == activeTab.value) {
                tabs[i].classList.add('tab-component__contents--active')
                headers[i].classList.add('tab-component__header-button--active')
            }
        }
    }

    const closeTab = (index) => {
        const tabs = document.querySelectorAll('.tab-component__contents');
        for (let i=0; i < tabs.length; i++) {
            if (i == index) {
                tabs[i].classList.remove('tab-component__contents--active')
                tabs[i].classList.add('tab-component__contents--disabled')
            }
        }
    }

    const calcHeight = () => {
        let height = 0;
        const tabs = document.querySelectorAll('.tab-component__contents');
        for(let i =0; i < tabs.length; i++) {
            if (tabs[i].getBoundingClientRect().height > height) {
                height = tabs[i].getBoundingClientRect().height;
            }
        }
        if(isTablet.value) {
            heighestContentTab.value = "auto";
        }
        else {
            heighestContentTab.value = height+"px";
        }
    }


    const toggleTab = (index) => {
        const headers = document.querySelectorAll('.tab-component__header-button')
        const tabs = document.querySelectorAll('.tab-component__contents');
        for (let i = 0; i < tabs.length; i++) {
            if (i == activeTab.value) {
                tabs[i].classList.remove('tab-component__contents--active')
                tabs[i].classList.add('tab-component__contents--disabled');
                if(!isTablet.value) {
                    headers[i].classList.remove('tab-component__header-button--active')
                    headers[i].classList.add('tab-component__header-button--disabled');
                }
            }
            if (i == index) {
                if(!isTablet.value) {
                    headers[i].classList.remove('tab-component__header-button--disabled')
                    headers[i].classList.add('tab-component__header-button--active')
                }
                tabs[i].classList.remove('tab-component__contents--disabled')
                tabs[i].classList.add('tab-component__contents--active')
            }
        }
        activeTab.value = index
    }

</script>